module.exports = __webpack_public_path__ + "static/00051.bc392d1b.jpg";